/**
 * 車輌検索ダイアログの p_car 呼び出し先（同一オリジンのプロキシ想定）。
 * Next 等では `NEXT_PUBLIC_SYARYO_PCAR_URL` で上書き可。
 */

/** @type {string} */
export const DEFAULT_SYARYO_PCAR_SEARCH_URL = "/api/syaryo/p-car";

/**
 * @param {string | undefined | null} pcarSearchUrl `""` のときのみモック検索。未指定は既定 URL または環境変数
 * @returns {string} 空文字のとき API 検索を行わない（モック）
 */
export function resolveSyaryoPcarSearchUrl(pcarSearchUrl) {
  if (pcarSearchUrl === "") return "";
  if (typeof pcarSearchUrl === "string" && pcarSearchUrl.trim() !== "") {
    return pcarSearchUrl.trim();
  }
  const fromEnv =
    typeof process !== "undefined" && process.env.NEXT_PUBLIC_SYARYO_PCAR_URL
      ? String(process.env.NEXT_PUBLIC_SYARYO_PCAR_URL).trim()
      : "";
  return fromEnv || DEFAULT_SYARYO_PCAR_SEARCH_URL;
}
